module.exports = __webpack_public_path__ + "img/1.fbd04c1a.jpg";